import { CIcon } from '~/icons/types'

export const ciUnderline: CIcon = {
  width: '24',
  height: '24',
  paths: [
    {
      d:
        'M12 17c1.87 0 3.628-.729 4.949-2.051A6.951 6.951 0 0 0 19 10V4a1 1 0 1 0-2 0v6a4.967 4.967 0 0 1-1.465 3.535A4.967 4.967 0 0 1 12 15a4.972 4.972 0 0 1-3.536-1.465A4.963 4.963 0 0 1 7 10V4a1 1 0 0 0-2 0v6c0 1.87.728 3.627 2.05 4.949A6.955 6.955 0 0 0 12 17Zm8 2H4a1 1 0 1 0 0 2h16a1 1 0 1 0 0-2Z'
    }
  ],
  ellipses: [],
  circles: [],
  name: 'underline',
  type: 'regular'
}
